import { combineReducers } from "redux";
import errorReducer from "./errorReducer";
import loginReducer from "./loginReducer";
import preLoginReducer from "./preLoginReducer";
import sessionReducer from "./sessionReducer";

import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

const persistConfig = {
  key: "root",
  storage: storage,
  blacklist: ["preLoginReducer", "sessionReducer"],
};

const rootReducer = combineReducers({
  errorReducer,
  loginReducer,
  preLoginReducer,
  sessionReducer,
});

export default persistReducer(persistConfig, rootReducer);